import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AppConfig } from "../config/config";
import { Observable } from "rxjs";
import { DtCrudCreate, DtForSelect } from "../models/dt.model";
import { ResponsePackage } from "shared-lib";
import { DtMapDto, DtPopupDto } from "../models/dt-map.model";
import { NetworkAssetTypes } from "../enums/network-asset-types.enum";

@Injectable({
    providedIn: 'root',
})
export class DtService {
    private pathApi: string;
    constructor(private http: HttpClient, private config: AppConfig) {
        this.pathApi = this.config.setting['pathApi'] + 'dt/';
    }

    private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    getAll(dataIn: any): Observable<any> {
        return this.http.post(`${this.pathApi}getAll`, dataIn, {
            observe: 'response',
        });
    }

    downloadFileCrud(dataIn: any): Observable<any> {
        return this.http.post(`${this.pathApi}downloadFileCrud`, dataIn);
    }

    saveCrud(dt: DtCrudCreate): Observable<any> {
        return this.http.post(`${this.pathApi}saveCrud`, dt, {
            observe: 'response',
        });
    }

    delete(id: number): Observable<any> {
        return this.http.delete(`${this.pathApi}delete/${id}`, {
            observe: 'response',
        });
    }

    getPopupInfo(id: number) {
        return this.http.get<ResponsePackage<DtPopupDto>>(`${this.pathApi}getPopupInfo/${id}`, { headers: this.headers, observe: 'response' });
    }

    getMapDetails(id: number) {
        return this.http.get<ResponsePackage<DtMapDto>>(`${this.pathApi}getMapDetails/${id}`, { headers: this.headers, observe: 'response' });
    }

    getDtIdsForNetworkAssets(
        parentId: number,
        parentType: NetworkAssetTypes
    ): Observable<any> {
        return this.http.get(
            `${this.pathApi}getDtIdsForNetworkAssets?parentId=${parentId}&parentType=` + parentType
        );
    }

    getAllForSelect(): Observable<any> {
        return this.http.get<ResponsePackage<DtForSelect[]>>(
            `${this.pathApi}getAllForSelect`,
            { headers: this.headers, observe: 'response' }
        );
    }

    getAllByFeeder(
        feederId: number,
        feederType: string,
        utilityId: number | null = null
    ): Observable<any> {
        if (utilityId) {
        return this.http.get(
            `${this.pathApi}getAllByFeeder?feederId=${feederId}&feederType=${feederType}&utilityId=${utilityId}`,
            { observe: 'response' }
        );
        } else {
        return this.http.get(
            `${this.pathApi}getAllByFeeder?feederId=${feederId}&feederType=${feederType}`,
            { observe: 'response' }
        );
        }
     }
}